import { cn } from '@shared/utils';
import { Error } from './error';

interface ErrorListProps {
  className?: string;
  errors?: (string | undefined)[];
}

export const ErrorList = (props: ErrorListProps) => {
  if (!props.errors?.some(Boolean)) return null;
  return (
    <div className={cn('flex flex-col gap-2 rounded-lg bg-[#e543381a] p-4', props.className)}>
      {props.errors.map((error, idx) => (
        <Error key={idx} text={error} />
      ))}
    </div>
  );
};
